module.exports = __webpack_public_path__ + "static/media/surper-4.0c01670e.jpg";